import { Info } from "lucide-react";
import React from "react";

import { IgSelect } from "@intelligems/ig-theme/IgSelect";
import { IgTooltip } from "@intelligems/ig-theme/IgTooltip";
import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { MenuItem, SelectChangeEvent } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useAnalyticsFetching } from "@src/api/analytics/hooks/use-analytics-fetching";
import { useDispatch, useSelector } from "@src/store";
import { updateDashboardFilter } from "@src/store/slices/dashboardFilters";

const TOP_N_OPTIONS = [10, 25, 50, 100];

export const ProductDetailsTableTopNSelect = () => {
  const dispatch = useDispatch();
  const topN = useSelector((state) => state.dashboardFilters?.topN) ?? 10;

  const isDataFetching = useAnalyticsFetching("variation_products");
  const handleChange = (event: SelectChangeEvent<unknown>) => {
    dispatch(
      updateDashboardFilter({
        key: "topN",
        value: event.target.value as number,
      })
    );
  };

  return (
    <Grid columnSpacing={1} alignItems={"center"} container>
      <Grid>
        <IgTypography>Top</IgTypography>
      </Grid>
      <Grid>
        <IgSelect
          disabled={isDataFetching > 0}
          value={topN ?? 10}
          onChange={handleChange}
        >
          {TOP_N_OPTIONS.map((n) => (
            <MenuItem
              sx={{ fontSize: "14px" }}
              disableTouchRipple={true}
              dense
              key={n}
              value={n}
            >
              {n}
            </MenuItem>
          ))}
        </IgSelect>
      </Grid>
      <Grid>
        <IgTypography>Products</IgTypography>
      </Grid>
      <IgTooltip
        title={
          "Filter to the top N products. The actual number of products returned could be less if there are fewer available in the test."
        }
      >
        <Info size={16} />
      </IgTooltip>
    </Grid>
  );
};
